import { render, staticRenderFns } from "./groupEditor.vue?vue&type=template&id=125e59a6&scoped=true"
import script from "./groupEditor.vue?vue&type=script&lang=js"
export * from "./groupEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125e59a6",
  null
  
)

export default component.exports